import "./App.css";
import Location from "./components/location/Location";
import { Routes, Route } from "react-router-dom";
import NorthStaking from "./components/north Staking/NorthStaking";
import WestStaking from "./components/west Staking/WestStaking";
import SouthStaking from "./components/south Staking/SouthStaking";
import EastStaking from "./components/east Staking/EastStaking";
import Mynftpage from "./components/mynfts"
import Mint from "./components/mint"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TopBar from "./components/header/navbar/TopBar";
import StakingPage from "./components/page/StakingPage";
import Footer from "./components/footer/Footer";
import MyDashboard from "./components/dashboard";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Location />} />
        <Route path="/eaststake" element={<EastStaking />} />
        <Route path="/weststake" element={<WestStaking />} />
        <Route path="/northstake" element={<NorthStaking />} />
        <Route path="/southstake" element={<SouthStaking />} />
        {/* <Route path="/mynfts" element={<Mynftpage />} /> */}
        <Route path="/mint" element={<Mint />} />
        <Route path="/Dashboard" element={<MyDashboard />} />
      </Routes>
    </div>
  );
}

export default App;
